import React from 'react';
import { ReviewContactDetails } from 'pages/components';

const ARReferralsContactReview = (props) => (
  <ReviewContactDetails {...props} />
);

export default ARReferralsContactReview;
